// No need for hardcoding, values are all in correct order
const numDesigns = 6;
const camo = [];

for ( let i = 0; i < numDesigns; i++ ) {
  const number = 100 + i;
  camo.push( {
    number: `HCM${number}`
  });
}

export default camo;